import React from 'react';
import styled, { css } from 'styled-components';
import { Button as antButton, ButtonProps } from 'antd';
import { colors, radius, fontWeight } from 'settings/style';

export interface ButtonComponentProps extends ButtonProps {
  leftIcon?: string | React.ReactElement;
  rightIcon?: string | React.ReactElement;
  primaryInfo?: boolean;
}
const ButtonComponent = ({ leftIcon, rightIcon, ...props }: ButtonComponentProps) => {
  return (
    <Button {...props}>
      {props.children}
      {leftIcon && (
        <span className="leftIconWrapper">
          {typeof leftIcon === 'string' ? <i className={leftIcon} /> : leftIcon}
        </span>
      )}
      {rightIcon && (
        <span className="rightIconWrapper">
          {typeof rightIcon === 'string' ? <i className={rightIcon} /> : rightIcon}
        </span>
      )}
    </Button>
  );
};

const Button = styled(antButton) <ButtonComponentProps>`
  ${({ primaryInfo, type }) =>
    type === 'default' ? css`
        border: 1px solid ${colors.gray300};
      border-radius: ${radius.lg};
      background: ${colors.white};
      color: ${colors.gray800};
      height: 40px !important;
      box-shadow: 0 2px 0 rgb(146 199 222 / 10%);
        &:hover {
          color: ${colors.gray600} !important;
          background: ${colors.gray50} !important;
          border-color: ${colors.gray300} !important;
        }
    ` : (type === 'primary' ?
      css`
      border: 1px solid ${colors.gray300};
      border-radius: ${radius.lg};
      background: ${colors.primary500};
      color: ${colors.primary800};
      height: 40px !important;
      font-weight: ${fontWeight.bold};
      box-shadow: none !important;
        &:hover {
          background: ${colors.primary600};
          color: ${colors.primary800} !important;
        }
    ` : (type === 'dashed' && css`
      border: none;
      border-radius: ${radius.lg};
      background: ${colors.grey900};
      color: white;
      height: 40px !important;
      font-weight: ${fontWeight.bold};
        &:hover {
          background: ${colors.grey700};
          color: white !important;
        }
        &:focus {
          background: ${colors.grey900};
          color: white !important;
        }
    `))}
`;

export default ButtonComponent;
